<p-toast></p-toast>
<ngx-spinner></ngx-spinner>
<ngx-spinner [name]="'benevo'" [fullScreen]="true" [bdColor]="'#ffffff'" template="<div style='width:100%;text-align:center;'>  <img style='width:50%;margin:auto;' src='assets/img/logo_pdf.png'/> </div>"></ngx-spinner>
<router-outlet id="mainRouter"></router-outlet>

